import { render } from "./SelectLanguage.vue?vue&type=template&id=6f69a00c"
import script from "./SelectLanguage.vue?vue&type=script&lang=js"
export * from "./SelectLanguage.vue?vue&type=script&lang=js"

import "./SelectLanguage.vue?vue&type=style&index=0&id=6f69a00c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__